export default __webpack_public_path__ + "images/apuracao-caixa-ico.svg";